import { fromJS } from 'immutable';
import {
  RECEIVE_BARBER,
  RECEIVE_BARBERS,
  REQUEST_BARBER_AVAILABLE_TIME,
  RECEIVE_BARBER_AVAILABLE_TIME,
} from '../constants';

const initialState = fromJS({
  items: [],
});

export default function barbersReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_BARBER: {
      const barberIndex = state.get('items').findIndex(barber => barber.get('id') === action.payload.id);
      return state.setIn(['items', barberIndex], action.payload);
    }

    case RECEIVE_BARBERS: {
      return state.set('items', fromJS(action.payload));
    }

    case RECEIVE_BARBER_AVAILABLE_TIME: {
      const barberIndex = state.get('items').findIndex(barber => barber.get('id') === action.payload.id);
      return state.setIn(['items', barberIndex, 'nextTime'], action.payload.nextTime);
    }

    case REQUEST_BARBER_AVAILABLE_TIME:
      return state;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/barbers/reducer.js